export interface FilterValues {
  from_date: string;
  to_date: string;
  contragent?: string;
  template_name?: string;
  project?: string;
  approver_name?: string;
  creator_name?: string;
  assigned_to_name?: string;
  locations?: string;
  location_id?: string;
  company_id?: string;
  department_id?: string;
  budget_type_id?: string;
  year?: string;
  role?: string;
}

export const emptyFilterValues: FilterValues = {
  from_date: "",
  to_date: "",
  contragent: "",
  template_name: "",
  project: "",
  approver_name: "",
  creator_name: "",
  assigned_to_name: "",
  locations: "",
  location_id: "",
  company_id: "",
  department_id: "",
  budget_type_id: "",
  year: "",
  role: "",
};
